import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentState } from '@data-layer/enums/payments/enumPaymentState';

@Pipe({
  name: 'paymentState',
})
export class PaymentStateTranslatePipe implements PipeTransform {
  public transform(value: enumPaymentState, withPrefix: boolean = true): any {
    return value !== null && value !== undefined
      ? (withPrefix ? 'PAYMENT_STATE.' : '') + enumPaymentState[value]
      : 'PAYMENT_STATE.NOT_PAID';
  }
}
